// Le bandeau des statuts, en haut du fil.
//
// Une bulle par membre, et non par statut : quelqu'un qui publie cinq fois dans
// la journée n'occupe pas cinq places. La plus récente sert de couverture, et un
// petit nombre dit combien il y en a.

import Store from "../store.js";
import { APP } from "../config.js";
import Avatar from "./Avatar.jsx";
import Certifie from "./Certifie.jsx";
import { composerStory } from "../views/story-composer.js";
import { ouvrirVisionneuse } from "./Visionneuse.jsx";
import { useAbonnement, useMembre } from "./hooks.js";

const FONDS = APP.fondsStory;

/** La couverture d'une bulle : l'image, la vidéo, ou le fond coloré du texte. */
function Apercu({ s }) {
  if (s.type === "image") return <img src={s.media} alt="" />;
  if (s.type === "video") return <video src={s.media} muted playsInline preload="metadata" />;
  return (
    <span className="story__fond" style={{ background: FONDS[s.fond || 0] }}>
      <span>{(s.texte || "").slice(0, 70)}</span>
    </span>
  );
}

function Bulle({ ss, libelle, onOuvrir, ctx }) {
  const derniere = ss[ss.length - 1];
  const auteur = useMembre(ctx, ss[0].authorId, { nom: ss[0].auteurNom, photo: ss[0].auteurPhoto });
  return (
    <button className="story" onClick={onOuvrir}>
      <span className="story__cover">
        <Apercu s={derniere} />
      </span>
      <span className="story__voile" />
      <span className="story__avatar">
        <Avatar membre={auteur} taille={36} />
      </span>
      {ss.length > 1 && <span className="story__nombre">{ss.length}</span>}
      <span className="story__nom">
        {libelle || auteur.nom}
        {!libelle && <Certifie membre={auteur} taille={11} />}
      </span>
    </button>
  );
}

export default function BandeauStories({ ctx }) {
  const stories = useAbonnement((cb) => Store.stories.subscribe(cb), []);

  // Regroupées par auteur, dans l'ordre d'arrivée des statuts.
  const parAuteur = new Map();
  for (const s of stories) {
    if (!parAuteur.has(s.authorId)) parAuteur.set(s.authorId, []);
    parAuteur.get(s.authorId).push(s);
  }
  const miennes = parAuteur.get(ctx.moi.uid) || [];
  const autres = [...parAuteur.entries()].filter(([id]) => id !== ctx.moi.uid);

  const ouvrir = (id) => ouvrirVisionneuse(stories, id, ctx, id === ctx.moi.uid);

  return (
    <div className="stories">
      <button className="story story--creer" onClick={() => composerStory(ctx)}>
        <span className="story__cover">
          {ctx.moi.photo ? (
            <img src={ctx.moi.photo} alt="" />
          ) : (
            <span className="story__fond" style={{ background: FONDS[0] }} />
          )}
        </span>
        <span className="story__creer-pied">
          <span className="story__plus">＋</span>
          <span>Créer une story</span>
        </span>
      </button>

      {/* Les miens d'abord : c'est le sien qu'on vérifie en premier. */}
      {miennes.length > 0 && <Bulle ss={miennes} libelle="Ma story" onOuvrir={() => ouvrir(ctx.moi.uid)} ctx={ctx} />}
      {autres.map(([id, ss]) => (
        <Bulle key={id} ss={ss} onOuvrir={() => ouvrir(id)} ctx={ctx} />
      ))}
    </div>
  );
}
